export default __webpack_public_path__ + "static/media/80_photo.3d4ed0cd.jpg";